// @flow
import React from 'react';

type PropType = {
  className?: String,
};

const T2AppleWatch = ({ className }: PropType) => {
  return (
    <>
      <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
        <defs>
          <style>{'.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:5px}'}</style>
        </defs>
        <title>{'square watch pos'}</title>
        <g id="Lager_1" data-name="Lager 1">
          <rect
            width={89.22}
            height={101}
            x={105.39}
            y={101.65}
            fill="none"
            stroke="#000"
            strokeMiterlimit={10}
            strokeWidth={'5px'}
            className="cls-1"
            rx={17.26}
          />
          <path
            d="M133.28 62.37h35.44A13.28 13.28 0 0 1 182 75.65v26h-62v-26a13.28 13.28 0 0 1 13.28-13.28ZM168.72 241.64h-35.44A13.28 13.28 0 0 1 120 228.36v-26h62v26a13.28 13.28 0 0 1-13.28 13.28ZM130 177.65l22-21-1-41"
            className="cls-1"
          />
        </g>
      </svg>
    </>
  );
};

export default T2AppleWatch;
